<template>
    <section class="author-profile-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-12" v-if="media >= 992">

                    <aside class="sidebar sidebar_author">
                        <profile-filter :media="media" :filters="filter" />

                        <profile-tabs :user="user"/>
                    </aside>

                </div>
                <div class="col-lg-8 col-md-12">
                    <div class="row">
                        <div class="col-md-12">
                            <user-about :user="user" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                          <user-description :user="user"/>
                        </div>
                    </div>

                    <div class="row" v-if="media < 992">
                         <div class="col-md-12">
                            <profile-filter :media="media"  :filters="filter"/>
                         </div>
                    </div>

                    <div class="row">
                         <div class="col-md-12">
                           <user-actual-pets :filter="profilePageList" :user="user" />
                         </div>
                    </div>

                    <div class="row" v-if="media < 992">
                        <div class="col-md-12">
                            <profile-tabs :user="user"/>
                        </div>
                    </div>


                </div>

            </div>

        </div>
    </section>
</template>

<script>

import UserAbout from "./UserAbout";
import UserDescription from "./UserDescription";
import ProfileFilter from "../ProfileFilter";
import UserActualPets from "./UserActualPets";
import ProfileTabs from "./UserProfileTabs";

export default {
    name: "UserProfile",
    props: ['user'],
    components: {UserAbout, UserDescription, ProfileFilter, UserActualPets, ProfileTabs},
    created() {
        this.myEventHandler()

        window.addEventListener("resize", this.myEventHandler);
    },
    destroyed(){
        window.removeEventListener("resize", this.myEventHandler);
    },


    data(){
        return{
            media: null,
            filter: {
                params: [
                    {
                        nameValue: 'actual',
                        title: this.$store.getters.t('user_profile_filter_actual_wards'),
                        checked: true
                    },
                    {
                        nameValue: 'projects',
                        title: this.$store.getters.t('user_profile_filter_projects'),
                        checked: false
                    },
                    {
                        nameValue: 'past',
                        title: this.$store.getters.t('user_profile_filter_past_wards'),
                        checked: false
                    },
                    {
                        nameValue: 'personal',
                        title: this.$store.getters.t('user_profile_filter_personal_pets'),
                        checked: false
                    }
                ],
                value: 'actual'
            },
        }
    },


    mounted() {
    },
    computed: {
        profilePageList(){

            let result = {
                title: '',
                petsType: '',
            }

            switch (this.filter.value){
                case "actual":
                    result.petsType = 'actual';
                    result.title = this.$store.getters.t('user_profile_filter_actual_wards');
                    break;
                case "projects":
                    result.petsType = 'projects';
                    result.title = this.$store.getters.t('user_profile_filter_projects');
                    break;
                case "past":
                    result.petsType = 'past';
                    result.title = this.$store.getters.t('user_profile_filter_past_wards');
                    break;
                case "personal":
                    result.petsType = 'personal';
                    result.title = this.$store.getters.t('user_profile_filter_personal_pets');
                    break;
            }

            return result

        },
    },
    methods:{

        myEventHandler(e){
            this.media = window.innerWidth
        },

    }
}
</script>

<style scoped>

</style>
